import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle } from 'react';
import { useNavigate } from 'react-router-dom';
import "../../../styles/balance.css";
// Popover import removed — TON balance now navigates to withdrawal page
import TicketConverterModal from '../../tickets/components/TicketConverterModal';
import SettingsModal from '../../legal/components/SettingsModal';
import { useUserRedux } from '../../../hooks/useUserRedux';
import { useWalletRedux } from '../hooks/useWalletRedux';
import { useWalletConnection } from '../contexts/WalletContext';
import { useAudio } from '../../../contexts/AudioContext';
import { useAnimatedNumber } from '../../../shared/hooks/useAnimatedNumber';
import logger from "../../../core/logger/logger";
import { useSelector } from "react-redux";

const Balance = forwardRef((props, ref) => {
  const tonRef = useRef();
  const ticketRef = useRef();
  const coinRef = useRef();
  const navigate = useNavigate();
  const [showConverter, setShowConverter] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useImperativeHandle(ref, () => ({
    ton: tonRef.current,
    ticket: ticketRef.current,
    coin: coinRef.current
  }));

  const wallet = useSelector((state) => state.wallet);

  const { data: user, refreshUser } = useUserRedux();
  const { refreshBalance } = useWalletRedux(); // Данные кошелька из Redux
  const { isConnected } = useWalletConnection(); // WebSocket соединение

  logger.info('wallet');
  logger.info(JSON.stringify(wallet));

  // Анимированные значения баланса
  // Для TON используем специальное форматирование, чтобы сохранить десятичные дроби
  // Добавлена задержка 500мс перед началом анимации
  const animatedCoins = useAnimatedNumber(wallet.datumCoins || 0, {
    duration: 1000,
    delay: 500,
    formatValue: (val) => Math.round(val) // Монеты - целые числа
  });
  const animatedTickets = useAnimatedNumber(wallet.tickets || 0, {
    duration: 1000,
    delay: 500,
    formatValue: (val) => Math.round(val) // Билеты - целые числа
  });
  const animatedTon = useAnimatedNumber(wallet.ton || 0, {
    duration: 1000,
    delay: 500,
    formatValue: (val) => {
      // TON может быть десятичным, сохраняем до 2 знаков после запятой
      // Во время анимации показываем с 2 знаками, в конце - как пришло
      return Math.round(val * 100) / 100;
    }
  });

  useEffect(() => {
    refreshUser();
    refreshBalance();
  }, []);

  return (
    <div className="balance-container">
      <div className="balance-group">
        {/* Coin */}
        <div className="balance-item" onClick={() => { navigate("/shop") }} data-reward-target="coins">
          <img className="icon" src="/coin_icon.png" alt="Coin" ref={coinRef} />
          <div className="value-bg">
            <span className="value-text">{animatedCoins}</span>
          </div>
          <img className="plus-icon" src="/Plus_Icon.png" alt="Coin" />
        </div>

        {/* TON */}
        <div className="balance-item" ref={tonRef} onClick={() => navigate('/ton-withdrawal')} style={{ position: 'relative' }} data-reward-target="ton">
          <img className="icon-ton" src="/gram.png" alt="GRAM" />
          <div className="value-bg">
            <span className="value-text">
              {typeof animatedTon === 'number' && animatedTon % 1 !== 0
                ? animatedTon.toFixed(1)
                : animatedTon}
            </span>
          </div>
        </div>

        {/* Ticket */}
        <div className="balance-item" ref={ticketRef} onClick={() => { setShowConverter(true) }} data-reward-target="tickets">
          <img className="icon ticket-icon" src="/ticket_icon.png" alt="Ticket" />
          <div className="value-bg">
            <span className="value-text">{animatedTickets}</span>
          </div>
          <img className="plus-icon" src="/Plus_Icon.png" alt="Ticket" />
        </div>

        {/* Settings: documents (privacy policy / offer / affiliate terms) */}
        <button type="button" className="balance-settings-btn" onClick={() => setShowSettings(true)} aria-label="Settings">
          <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
            <path
              fill="currentColor"
              d="M19.14 12.94a7.4 7.4 0 0 0 .05-.94 7.4 7.4 0 0 0-.05-.94l2.03-1.58a.5.5 0 0 0 .12-.64l-1.92-3.32a.5.5 0 0 0-.6-.22l-2.39.96a7.03 7.03 0 0 0-1.63-.94l-.36-2.54A.5.5 0 0 0 13.9 2.4h-3.8a.5.5 0 0 0-.49.42l-.36 2.54c-.59.24-1.13.56-1.63.94l-2.39-.96a.5.5 0 0 0-.6.22L2.71 8.88a.5.5 0 0 0 .12.64l2.03 1.58a7.4 7.4 0 0 0-.05.94c0 .32.02.63.05.94l-2.03 1.58a.5.5 0 0 0-.12.64l1.92 3.32c.13.22.39.3.6.22l2.39-.96c.5.38 1.04.7 1.63.94l.36 2.54c.04.24.25.42.49.42h3.8c.24 0 .45-.18.49-.42l.36-2.54c.59-.24 1.13-.56 1.63-.94l2.39.96c.22.08.47 0 .6-.22l1.92-3.32a.5.5 0 0 0-.12-.64l-2.03-1.58ZM12 15.6a3.6 3.6 0 1 1 0-7.2 3.6 3.6 0 0 1 0 7.2Z"
            />
          </svg>
        </button>
      </div>
      {showConverter && (
        <TicketConverterModal onClose={() => setShowConverter(false)} />
      )}
      {showSettings && (
        <SettingsModal onClose={() => setShowSettings(false)} />
      )}
    </div>
  );
});

export default Balance;
